<template>
  <div data-v-f531b812="" class="app app-ti_green metransRecord">
    <div data-v-8a75a126="" data-v-f531b812="" class="header">
      <div data-v-8a75a126="" class="header__top-wrapper">
        <div data-v-8a75a126="" class="van-nav-bar van-nav-bar--fixed fixed-top rounded-corners nav-header">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="$router.back()">
              <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis">充值信息</div>
            <!-- <div class="van-nav-bar__right" @click="$parent.openKefu">
              <div class="header-style-icon"><img src="/static/image/kefuIcon.9bf50982.png" /></div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  <div style="height:40px"></div>
    <div data-v-334775a8="" data-v-f531b812="" class="wrapper green-wrapper">
      <div data-v-334775a8="">
        <div data-v-334775a8="" class="PayInfoTime green-PayInfoTime">
          <div class="PayAmount">
            <span class="Amount">{{ payInfo.info.amount }}</span
            ><span> 元 </span>
          </div>
          <!-- USDT金额显示 -->
          <div v-if="type == 'usdtpay' && payInfo.info.real_money" class="UsdtAmount">
            <span>≈ {{ payInfo.info.real_money }} USDT</span>
          </div>
          <!-- 汇率显示 -->
          <div v-if="type == 'usdtpay' && payInfo.info.usdtrate" class="ExchangeRate">
            <span>汇率: 1 USDT = {{ payInfo.info.usdtrate }} CNY</span>
          </div>
          <div class="Countdown">
            <div>
              请在<span place="time">{{ m >= 10 ? m : `0${m}` }}：{{ s >= 10 ? s : `0${s}` }}</span
              >内完成支付
            </div>
          </div>
          <div>成功付款后，将自动到账！</div>
          <div>如有问题，请<span place="thing" class="contact-customer" @click="$parent.openKefu"> 联系客服 </span>确认</div>
        </div>
      </div>

      <div data-v-334775a8="" class="transaction-detail bg">
        <p data-v-334775a8="" v-if="type == 'usdtpay'">
          <span data-v-334775a8=""> 收款地址 </span
          ><span data-v-334775a8="" style="word-break: break-word; max-width: 240px"
            ><span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.cardlist.mch_id }}</span
            ><span @click="doCopy(payInfo.cardlist.mch_id)" data-v-334775a8="" class="copy"> 复制 </span></span
          >
        </p>

        <p data-v-334775a8="">
          <span data-v-334775a8=""> 订单号 </span
          ><span data-v-334775a8=""
            ><span data-v-334775a8="" class="transNum paddingSty">{{ payInfo.deposit_no }}</span
            ><span v-if="false" data-v-334775a8="" class="copy"> 复制 </span></span
          >
        </p>
        <p data-v-334775a8="">交易时间 <span data-v-334775a8="" class="tran-time"> {{ payInfo.info.created_at }} </span></p>
        <p data-v-334775a8="">
          充值方式<span data-v-334775a8="" class="tran-type">{{ payInfo.info.paytype }}</span>
        </p>
            <p data-v-334775a8="" v-if="type =='usdtpay'">
          钱包协议<span data-v-334775a8="" class="tran-type">{{ payInfo.cardlist.content }}</span>
        </p>
        <img :src="payInfo.cardlist.payimg" style="width:80%;display:block;margin:10px auto" alt="" />
      </div>
      <div v-if="supportsReceipt" class="receipt-panel">
        <div class="receipt-title">充值凭证</div>
        <div class="receipt-hint">完成转账后上传支付凭证，方便客服核实到账。</div>
        <img v-if="receiptUrl" class="receipt-preview" :src="receiptUrl" alt="充值凭证" @click="previewReceipt" />
        <div v-if="Number(payInfo.info.state) !== 1" class="receipt-status">{{ receiptUrl ? '订单已审核，凭证已提交' : '订单已审核' }}</div>
        <label v-else class="receipt-upload" :class="{ disabled: uploadingReceipt }">
          {{ uploadingReceipt ? '上传中…' : (receiptUrl ? '更换凭证' : '上传支付凭证') }}
          <input type="file" accept="image/jpeg,image/png,image/webp" :disabled="uploadingReceipt" @change="uploadReceipt" />
        </label>
        <div v-if="receiptUrl && Number(payInfo.info.state) === 1" class="receipt-status">凭证已提交，等待审核</div>
      </div>
      <div data-v-334775a8="" class="footer">
        <div data-v-334775a8="" class="goback-button" @click="$parent.goNav('/transRecord')">
          <img
            data-v-334775a8=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAMAAADpVnyHAAAAPFBMVEVHcEwLqoUPqIUPqIYIp4cAr4AOqIYMp4cOp4UNp4UPqIYPqIYPqIYOp4YOqIUPqIYOqIUPp4UNqYYPqIanHmPRAAAAE3RSTlMAMO/wIBBwQIBg0MDfoLCvkOBQvn0j8QAAAJFJREFUGBl1wYkBwiAQBMAlPHdAXrf/XgVJFA3OoOMi/ogTBUM7yYABn1ko7szMSnETJ74ofu08beLQ8xs7c/C4mMRvs6AxE28ULwcHIirLkYgicmRyKMRyIKNyiQOCyi88LSJRV1YZTWCjqJxakg6NWFaKxiQy4OQSC8XJr1xx8QvJgIs/Mj4CafAmREce6MgTIHASgfcpjWAAAAAASUVORK5CYII="
            class="icon"
          /><span data-v-334775a8="">充值完成</span>
        </div>
        <div data-v-334775a8="" class="seedetail-button" @click="$parent.goNav('/transRecord')">
          <img
            data-v-334775a8=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAOVBMVEUMqIcPqIYOqIUOqIYPqIUAr4ALqoVHcEwPp4YOqYcNp4UPqIYPp4UOqIYOqIUIp4cNqYYOqIUPqIbGVSZiAAAAEnRSTlM/0JBw8BAwAMB/YN/goG8gULADspVqAAAAtklEQVQoz42S2xbEEAxFg0hCbzP5/48d2lqL0mnPm2xHboDZL5NeZCwnAW+oA5mdfXX+wEURNWSmCtwpqiRGqj1iyFGAJxZDo1gzaYuUmllpZN/mo7Y9epvvHxvrmZ1v5oBfZZLgR4yOXSLxpYfkMooWHCr6Lp87HH5W2zFRe94xAxarmdGNT7o/UfKd/2VRXKHUyXudAXcD5LKLcn/llPy5JydYzcWl5YYt+QluZplem+8Ye6EfKyMbAQTPPjYAAAAASUVORK5CYII="
            class="icon"
          /><span data-v-334775a8="">资金明细</span>
        </div>
      </div>
      <!---->
    </div>

    <div data-v-f531b812="" class="float-divbox"></div>
    <span data-v-7b0f8a3e="" data-v-f531b812="" class="customer-service-container"></span><span data-v-f531b812=""></span>
    <div data-v-55ec3770="" data-v-f531b812="" class="select-service-line-view select-service-line-view">
      <dl data-v-55ec3770="" class="select-service-list"><div data-v-55ec3770="" style="height: 55px"></div></dl>
    </div>
  </div>
</template>
<script>
export default {
  name: 'payInfo',
  data() {
    return {
      payInfo: {},
      type: null,
      daoTime: null,
      m: 0,
      s: 0,
      receiptUrl: '',
      uploadingReceipt: false,
    };
  },
  created() {
    let that = this;

    var query = that.$route.query;
    if (query.deposit_no) {
      that.getpayinfo(query.deposit_no);
    }
  },
  methods: {
    receiptUrlFor(path) {
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      const baseUrl = sessionStorage.getItem('baseURL') || '';
      return baseUrl.replace(/\/$/, '') + '/uploads/' + String(path).replace(/^\/+/, '');
    },
    uploadReceipt(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        this.$parent.showTost(0, '凭证仅支持 JPG、PNG 或 WEBP 图片');
        event.target.value = '';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$parent.showTost(0, '图片不能超过5MB');
        event.target.value = '';
        return;
      }
      const formData = new FormData();
      formData.append('deposit_no', this.$route.query.deposit_no);
      formData.append('file', file);
      this.uploadingReceipt = true;
      this.$parent.showLoading();
      this.$apiFun.post('/api/recharge-receipt-upload', formData).then(res => {
        if (res.code === 200) {
          this.$parent.showTost(1, '凭证上传成功');
          this.getpayinfo(this.$route.query.deposit_no);
        } else {
          this.$parent.showTost(0, res.message || '凭证上传失败');
        }
      }).catch(() => {
        this.$parent.showTost(0, '凭证上传失败，请稍后重试');
      }).finally(() => {
        this.uploadingReceipt = false;
        this.$parent.hideLoading();
        event.target.value = '';
      });
    },
    previewReceipt() {
      if (this.receiptUrl) window.open(this.receiptUrl, '_blank');
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
    getpayinfo(deposit_no) {
      let that = this;
      this.$parent.showLoading();

      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.receiptUrl = that.receiptUrlFor(res.data.info.receipt_url || res.data.info.receipt_path);
          that.type = res.message;
          that.countTime();
        }
        this.$parent.hideLoading();
      });
    },
    countTime() {
      //获取当前时间
      let that = this;
      var date = new Date();
      var now = date.getTime(); //当前时间
      //   创建时间
      let created_at = that.payInfo.info.created_at;
      let createdTime = new Date(created_at).getTime();
      //设置截止时间
      var end = createdTime + 1000 * 60 * 60;
      //时间差
      var leftTime = end - now;

      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // that.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        that.m = Math.floor((leftTime / 1000 / 60) % 60);
        that.s = Math.floor((leftTime / 1000) % 60);
      } else {
        // $('.time').html('00:00');
        clearInterval(that.countTime);
        that.countTime = null;

        return;
      }
      let m = that.m >= 10 ? that.m : `0${that.m}`;
      let s = that.s >= 10 ? that.s : `0${that.s}`;
      // $('.time').html(`${m}:${s}`);
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000);
    },
  },
  computed: {
    supportsReceipt() {
      return this.payInfo.info && [1, 3, 4, 5, 6, 7].includes(Number(this.payInfo.info.pay_way));
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.countTime) {
      clearInterval(that.countTime);
    }
    that.countTime = null;
  },
};
</script>
<style lang="scss" scoped>
@import '../../static/css/fund-recharge-info.dba269b9.css';

.receipt-panel { margin: 12px 0; padding: 16px; background: #fff; border-radius: 6px; text-align: center; }
.receipt-title { font-size: 16px; font-weight: 600; color: #222; }
.receipt-hint { margin: 8px 0 12px; font-size: 12px; color: #888; }
.receipt-preview { display: block; max-width: 100%; max-height: 260px; margin: 0 auto 10px; object-fit: contain; }
.receipt-upload { display: inline-block; padding: 9px 22px; color: #fff; background: #0b4fc7; border-radius: 4px; font-size: 14px; }
.receipt-upload.disabled { opacity: .6; }
.receipt-upload input { display: none; }
.receipt-status { margin-top: 8px; font-size: 12px; color: #19a684; }

// USDT金额显示样式
.UsdtAmount {
  font-size: 18px;
  font-weight: 600;
  color: #3e40ea;
  margin: 10px 0;
  text-align: center;
}

// 汇率显示样式
.ExchangeRate {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
  text-align: center;
  background: #f5f7ff;
  padding: 8px 16px;
  border-radius: 20px;
  display: inline-block;
  margin-left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/payInfo.vue